import "./assets/syfIframeStyles.css";
import config from "./configuration/configuration";
import * as empqIntegration from "./empq-integration/syf-empq";


startLazyLoaderMatrix(
  getEnvironmentDetails.bind()
);

function startLazyLoaderMatrix(callback) {
  window['__syfEMPQ__'] = {};
  window['__syfEMPQ__']['matrix'] = { 'SyfEmpq': { 'ENV_CONFIG': { 'start': '', 'end': '', 'isLoadComplete': false } }, 'WIDGET': {} };
  callback();
}

let syfProduct = {};

function attachCSSToDOM() {
  let syfModal = "syf-modal-css";
  var head = document.getElementsByTagName("head")[0];
  if (!document.getElementById(syfModal)) {
    var link = document.createElement("link");
    link.id = syfModal;
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href =
      config[config.env].syfMPPURL + config[config.env].syfIFrameStyles;
    link.media = "all";
    head.appendChild(link);
  }

}

function getEnvironmentDetails() {
  window["__syfEMPQ__"]["matrix"]["SyfEmpq"]["ENV_CONFIG"]["start"] = Date.now();
  let scriptElement = document.getElementById("syfEMPQscript");
  scriptElement =
    scriptElement === null ? empqIntegration.getModalScriptElementOnMissingId() : scriptElement;
  let scriptHost;
  let envURL;
  if (!scriptElement) {
    console.error("Integration Script Missing.Id should be matched.");
  } else {
    scriptHost = scriptElement.src;
    envURL = scriptHost.substring(0, scriptHost.lastIndexOf("/"));
    envURL = envURL + "/env-config.js";
  }

  let script = document.createElement("script");
  script.src = envURL;

  document.getElementsByTagName("head")[0].appendChild(script);

  script.onload = function () {
    console.log({ empqScriptStart: 'loadSyfEmpq script start' });
    config.env = window._syfMpp_.SYF_MPP_ENV;
    window["__syfEMPQ__"]["matrix"]["SyfEmpq"]["ENV_CONFIG"][
      "isLoadComplete"
    ] = true;
    window["__syfEMPQ__"]["matrix"]["SyfEmpq"]["ENV_CONFIG"]["end"] = Date.now();
    console.log({ empqScriptEnd: 'loadSyfEmpq script end' });
  };
}

// Empq initiating method and adding styles
export function loadSyfEmpq() {
  console.log({ empqStart: 'loadSyfEmpq start' });
  attachCSSToDOM();
  waitAndExecute(
    window["__syfEMPQ__"]["matrix"]["SyfEmpq"]["ENV_CONFIG"]["isLoadComplete"],
    loadEMPQImpl.bind(this)
  );
  console.log({ empqEnd: 'loadSyfEmpq end' });
}

function waitAndExecute(isSatisfied, callback) {
  let waitTime = 5;// unit: ms
  window.setTimeout(() => {
    if (isSatisfied) {
      console.log({ empqCallback: 'loadSyfEmpq callback' });
      callback();
    } else {
      console.log({ empqWait: 'loadSyfEmpq wait and execute' });
      waitAndExecute(window["__syfEMPQ__"]["matrix"]["SyfEmpq"]["ENV_CONFIG"]["isLoadComplete"], callback);
    }
  }, waitTime);

}

// reading syfObject (from merchant) and calling modal open
function loadEMPQImpl() {
  let syfEmpqObject;
  if (syfObject) {
    syfEmpqObject = Object.assign({}, syfObject);
  }
  syfProduct.activeProduct = Object.assign({}, empqIntegration);
  syfProduct.activeProduct.openSYFModal(syfEmpqObject);
}



export default {
  syfProduct,
  loadSyfEmpq,
};